module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3Mqjho/tc-custom/9781649794055.jpg?1724535441652",
      "alt": "This image is the cover for the book Darkness Surrounds the Light"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Darkness Surrounds the Light\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Where do you place your faith? Where do you go to when you need help? When patiently waiting to be saved does not work, whose arms should you fall into? ")]), _c('p', [_vm._v("In "), _c('em', [_vm._v("Darkness Surrounds the Light,")]), _vm._v(" Shirley, a young woman in a foreign country, has to face trials and frustrations and danger without knowing how she will survive or who she can trust. She is captured and tortured for no reason and faces unmentionable abuse not knowing who to lean on or how she will survive. Even when she feels safe, she still has to keep up her guard and fight with her demons. She thought her savior was Shawn, but he could not protect her. ")]), _c('p', [_vm._v("Who will protect her? Who can she trust when the hope of rescue appears to be out of reach?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Charleyna East\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin-top": "0cm",
      "margin-right": "0cm",
      "margin-bottom": "8.0pt",
      "margin-left": "0cm",
      "font-size": "15px",
      "font-family": "\"Aptos\",sans-serif"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif"
    }
  }, [_vm._v("Charleyna East is an English Teacher, who loves to write when she is not reaching the minds of students. She has a Bachelors and Master’s in Education. With a background in creative writing and a love for describing things in detail, she enjoys writing poetry, informational articles and fictional tales that tell a story or prod the mind. Although she lives in the small town of Prattville, Alabama, she loves to take her readers on journeys to other worlds.")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0